import { useEffect, useState, useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";
import { LanguageContext } from "../../../context/LanguageContext";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./homecategoryswipper.css";
import CustomCarouselSliders from "../../customslider/customslider";
import RoyalDivider from "../../../components/divider/royalDivider";
import { getLimitedImages } from "../../../config/pageDetails";

const CustomSlider = ({ slide }) => {
  const images = getLimitedImages(
    slide?.imageUrl,
    "homeCategory",
    "cardImageLimit"
  );

  return (
    <div>
      <CustomCarouselSliders>
        {images.map((image, index) => {
          return (
            <div key={index}>
              <img
                key={index}
                className="image-home-category"
                src={image}
                alt={slide.name}
              />
            </div>
          );
        })}
      </CustomCarouselSliders>
    </div>
  );
};

const HomeCategorySwipper = () => {
  const { t } = useContext(LanguageContext);
  const [slides, setSlides] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/api/categories?offset=0")
      .then((response) => response.json())
      .then((data) => {
        setSlides(data.categories);
      })
      .catch((error) => console.error("Error fetching slides:", error.message));
  }, []);

  const handleMenuClick = (slide) => {
    const route = slide.name.toLowerCase().replace(/\s+/g, "");
    navigate(route === "home" ? "/" : `/subcategory`, { state: { slide } });
  };

  return (
    <div className="swiper-container">
      <RoyalDivider />
      <div className="home-category-head">
        <button
          className="btn-home-category-swipper"
          onClick={() => navigate("/category")}
        >
          {t(`HomeCategorySwipper.viewAllCategories`)}
        </button>
      </div>

      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        loop={false}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
        }}
        pagination={{ el: ".swiper-pagination", clickable: true }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          clickable: true,
        }}
        modules={[EffectCoverflow, Pagination, Navigation]}
        className="home-swiper"
      >
        {slides &&
          slides.map((slide, index) => (
            <SwiperSlide key={index} className="swiper-slide-custom">
              <CustomSlider slide={slide} />
              <div className="slide-title">{slide.name}</div>
              <button
                className="btn-home-category-swipper"
                onClick={() => handleMenuClick(slide)}
              >
                {t(`HomeCategorySwipper.viewAll`)}
              </button>
            </SwiperSlide>
          ))}

        <div className="swiper-button-prev slider-arrow"></div>
        <div className="swiper-button-next slider-arrow"></div>
        <div className="swiper-pagination"></div>
      </Swiper>
    </div>
  );
};

export default HomeCategorySwipper;
